export const UnloadingDockPattern = {
  Single: "Single", // 10
  Linear: "Linear", // 20
  // TMP: 予約語
  // Multi: 'Multi', // 30
  // Yagura: 'Yagura', // 40
} as const;
